import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { CoreHttpClient } from "../http-client/http-client.service";

import { AuthTransactionConfigService } from "./auth-transaction.config";
import {
	AuthTransactionRequest,
	AuthTransactionResponse,
	AuthTransactionResponseV2,
	AuthenticationType,
	CancelRequest,
	VerificationRequest,
	VerificationRequestV2,
	VerificationStatusRequest,
	VerificationStatusResponse,
} from "./auth-transaction.model";

@Injectable({
	providedIn: "root",
})
export class AuthTransactionService {
	constructor(
		private httpClient: CoreHttpClient,
		private config: AuthTransactionConfigService
	) {}

	getStatus(request: VerificationStatusRequest): Observable<VerificationStatusResponse> {
		return this.httpClient.get<VerificationStatusResponse>({
			url: this.config.getVerificationStatusEndpoint(),
			searchParams: {
				authenticationType: AuthenticationType.BankId,
				...request,
			},
		});
	}

	initializeVerification(request: VerificationRequest): Observable<AuthTransactionResponse> {
		return this.httpClient.post<AuthTransactionResponse>({
			url: this.config.getVerificationEndpoint(),
			data: request,
		});
	}

	initializeVerificationV2(verificationRequestV2: VerificationRequestV2): Observable<AuthTransactionResponseV2> {
		return this.httpClient.post<AuthTransactionResponseV2>({
			url: this.config.getVerificationEndpointV2(),
			data: verificationRequestV2,
		});
	}

	initializeAuthTransaction(request?: AuthTransactionRequest): Observable<AuthTransactionResponse> {
		return this.httpClient.post<AuthTransactionResponse>({
			url: this.config.getVerificationEndpoint(),
			data: {
				authenticationType: AuthenticationType.BankId,
				...request,
			},
		});
	}

	cancelVerification(request: CancelRequest): Observable<object> {
		return this.httpClient.delete({
			url: this.config.getVerificationEndpoint(),
			searchParams: request,
		});
	}
}
